import AuthorContainer from './Author.jsx';

export default AuthorContainer;
